/**
 * 集合页 ?q=handle1,handle2,... 兜底（筛选 AJAX 等）：
 * - Liquid 已 SSR 且 data-collection-q-skip-init：不跑首屏 schedule、不挂 MutationObserver
 * - 否则：首屏校正；Liquid 会在需 JS 时给 html 加 collection-q-pending，本脚本完成后移除，避免先看到错误顺序再重排
 */
(function () {
  var cachedHandles = null;
  var scheduleGeneration = 0;
  var debounceTimer;

  function releaseCollectionQPending() {
    document.documentElement.classList.remove('collection-q-pending');
  }

  /** 忽略中间的 .js-card-text 等，只比较「前 len(q) 个 card-product」是否与 q 中 handle 顺序一致（服务端已排好） */
  function leadingHandlesMatchGrid(grid, handles) {
    if (!grid || !handles || !handles.length) {
      return false;
    }
    var qi = 0;
    var wantLen = handles.length;
    for (var i = 0; i < grid.children.length && qi < wantLen; i++) {
      var el = grid.children[i];
      if (!el.matches || !el.matches('card-product')) {
        continue;
      }
      var want = handles[qi].toLowerCase();
      if ((el.dataset.handle || '').toLowerCase() !== want) {
        return false;
      }
      qi++;
    }
    return qi === wantLen;
  }

  function storeRoot() {
    if (typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    if (typeof window.shopUrl === 'string' && window.shopUrl) {
      return window.shopUrl.endsWith('/') ? window.shopUrl : window.shopUrl + '/';
    }
    return '/';
  }

  function parsePinHandles() {
    try {
      var params = new URLSearchParams(window.location.search);
      var pg = params.get('page');
      if (pg != null && pg !== '' && parseInt(pg, 10) > 1) {
        return null;
      }
      var raw = params.get('q');
      if (raw) {
        var qOnly = raw.split('&')[0];
        var handles = qOnly.split(',').map(function (s) {
          try {
            return decodeURIComponent(s.trim());
          } catch (e) {
            return s.trim();
          }
        }).filter(Boolean);
        if (handles.length) {
          if (!pg || parseInt(pg, 10) <= 1) {
            cachedHandles = handles;
          }
          return handles;
        }
      }
    } catch (e) {
      /* ignore */
    }
    var pg2 = new URLSearchParams(window.location.search).get('page');
    if (pg2 != null && pg2 !== '' && parseInt(pg2, 10) > 1) {
      return null;
    }
    if (cachedHandles && cachedHandles.length) {
      return cachedHandles;
    }
    return null;
  }

  function findCardInGrid(grid, handleLower) {
    var list = grid.querySelectorAll('card-product[data-handle]');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      var dh = (el.dataset && el.dataset.handle) || '';
      if (dh.toLowerCase() === handleLower) {
        return el;
      }
    }
    return null;
  }

  function fetchProductCard(handle) {
    var root = storeRoot();
    var base =
      root === '/' ? '' : root.endsWith('/') ? root.slice(0, -1) : root;
    var path = (base || '') + '/products/' + encodeURIComponent(handle) + '?view=card';
    return fetch(path, { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) {
        return null;
      }
      return res.text();
    }).then(function (html) {
      if (!html) {
        return null;
      }
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var card = doc.querySelector('card-product');
      if (!card) {
        return null;
      }
      try {
        return document.importNode(card, true);
      } catch (e) {
        return card;
      }
    }).catch(function () {
      return null;
    });
  }

  async function reorderProductGrid(gen) {
    try {
      if (!document.body.classList.contains('template--collection')) {
        return;
      }

      var handles = parsePinHandles();
      if (!handles || !handles.length) {
        return;
      }

      var grid = document.getElementById('product-grid');
      if (!grid) {
        return;
      }

      if (leadingHandlesMatchGrid(grid, handles)) {
        return;
      }

      var pinSet = new Map();
      var pinEls = [];

      for (var i = 0; i < handles.length; i++) {
        if (gen !== scheduleGeneration) {
          return;
        }
        var rawHandle = handles[i];
        var hLower = rawHandle.toLowerCase();
        var existing = findCardInGrid(grid, hLower);
        if (existing && !pinSet.has(existing)) {
          pinEls.push(existing);
          pinSet.set(existing, true);
          continue;
        }
        if (existing && pinSet.has(existing)) {
          continue;
        }
        var fetched = await fetchProductCard(rawHandle);
        if (gen !== scheduleGeneration) {
          return;
        }
        if (fetched && !pinSet.has(fetched)) {
          fetched.setAttribute('data-q-priority-injected', '1');
          pinEls.push(fetched);
          pinSet.set(fetched, true);
        }
      }

      if (!pinEls.length) {
        return;
      }

      if (gen !== scheduleGeneration) {
        return;
      }

      var nowChildren = Array.prototype.slice.call(grid.children);
      var rest = nowChildren.filter(function (n) {
        return !pinSet.has(n);
      });

      var same = true;
      var t;
      for (t = 0; t < pinEls.length; t++) {
        if (grid.children[t] !== pinEls[t]) {
          same = false;
          break;
        }
      }
      if (same) {
        for (t = 0; t < rest.length; t++) {
          if (grid.children[pinEls.length + t] !== rest[t]) {
            same = false;
            break;
          }
        }
      }
      if (same) {
        return;
      }

      var frag = document.createDocumentFragment();
      pinEls.forEach(function (n) {
        frag.appendChild(n);
      });
      rest.forEach(function (n) {
        frag.appendChild(n);
      });
      grid.appendChild(frag);
    } finally {
      if (gen === scheduleGeneration) {
        releaseCollectionQPending();
      }
    }
  }

  function schedule(immediate) {
    clearTimeout(debounceTimer);
    scheduleGeneration += 1;
    var gen = scheduleGeneration;
    if (immediate) {
      var h = parsePinHandles();
      var g = document.getElementById('product-grid');
      if (h && g && leadingHandlesMatchGrid(g, h)) {
        releaseCollectionQPending();
        return;
      }
      reorderProductGrid(gen).catch(function () {});
      return;
    }
    debounceTimer = setTimeout(function () {
      reorderProductGrid(gen).catch(function () {});
    }, 50);
  }

  function collectionQSkipInit() {
    var g = document.getElementById('product-grid');
    return g && g.getAttribute('data-collection-q-skip-init') === '1';
  }

  if (collectionQSkipInit()) {
    releaseCollectionQPending();
  }

  if (!collectionQSkipInit()) {
    var gridEarly = document.getElementById('product-grid');
    var pinsEarly = parsePinHandles();
    if (gridEarly && pinsEarly && pinsEarly.length) {
      schedule(true);
    } else if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        schedule(true);
      });
    } else {
      schedule(true);
    }
  }

  var container = document.getElementById('ProductGridContainer');
  if (
    !collectionQSkipInit() &&
    document.body.classList.contains('template--collection') &&
    container &&
    typeof MutationObserver !== 'undefined'
  ) {
    var mo = new MutationObserver(function () {
      schedule(false);
    });
    mo.observe(container, { childList: true, subtree: true });
  }

  function wrapFacetRender() {
    if (typeof FacetFiltersForm === 'undefined' || FacetFiltersForm.__collectionQPatched) {
      return;
    }
    FacetFiltersForm.__collectionQPatched = true;
    var orig = FacetFiltersForm.renderProductGridContainer;
    FacetFiltersForm.renderProductGridContainer = function (html) {
      orig(html);
      schedule(false);
    };
  }

  var attempts = 0;
  function tryWrapFacet() {
    if (typeof FacetFiltersForm !== 'undefined') {
      wrapFacetRender();
      return;
    }
    if (attempts++ < 60) {
      setTimeout(tryWrapFacet, 100);
    }
  }

  document.addEventListener('DOMContentLoaded', tryWrapFacet);
})();
